export default "__VITE_ASSET__B52sKB3G__"